"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HtmlTagImporterBase = void 0;
var list_1 = require("@devexpress/utils/lib/utils/list");
var HtmlTagImporterBase = (function () {
    function HtmlTagImporterBase(importer) {
        this.importer = importer;
    }
    Object.defineProperty(HtmlTagImporterBase.prototype, "colorProvider", {
        get: function () { return this.importer.modelManager.model.colorProvider; },
        enumerable: false,
        configurable: true
    });
    HtmlTagImporterBase.prototype.getClosestImporterByTagName = function (tagName) {
        return list_1.ListUtils.reverseElementBy(this.importer.levelInfo, function (levelInfo) { return levelInfo.tagImporter.elementTag() == tagName; }).tagImporter;
    };
    HtmlTagImporterBase.prototype.isAllowed = function () {
        return true;
    };
    HtmlTagImporterBase.prototype.addRun = function (run) {
        this.importer.addRun(run);
    };
    Object.defineProperty(HtmlTagImporterBase.prototype, "element", {
        get: function () {
            return this.importer.currElement;
        },
        enumerable: false,
        configurable: true
    });
    return HtmlTagImporterBase;
}());
exports.HtmlTagImporterBase = HtmlTagImporterBase;
